class AudioTrackAction {
    constructor(type, sourceBars = [], targetBars, split, barLength) {
        this._type = type;
        this._sourceTime = this.convertBarsToLength(sourceBars, barLength);
        this._targetTime = this.convertBarsToLength(targetBars, barLength);
        this._split = split;
    }

    convertBarsToLength = (bars, barLength) => {
        let barTime = {};
        if (bars.length > 0) {
            bars.sort((a, b) => a - b);
            barTime = {
                start: bars[0] * barLength,
                end: (bars[bars.length - 1] + 1) * barLength
            };
        }
        return barTime;
    };


    get type() {
        return this._type;
    }

    set type(value) {
        this._type = value;
    }

    // get sourceTime() {
    //     return this._sourceTime;
    // }
    //
    // set sourceTime(value) {
    //     this._sourceTime = value;
    // }

    get targetTime() {
        return this._targetTime;
    }

    set targetTime(value) {
        this._targetTime = value;
    }


    get split() {
        return this._split;
    }

    set split(value) {
        this._split = value;
    }
}

export default AudioTrackAction;
